module.exports = __webpack_public_path__ + "img/mt-logo.57b4e730.png";